import React from 'react';
import IconButton from '@mui/material/IconButton';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import EqualizerIcon from '@mui/icons-material/Equalizer';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import PauseIcon from '@mui/icons-material/Pause';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import { isMobile } from 'react-device-detect';
import { useNavigate } from 'react-router-dom';
import { formatTime, useIsMobileDimensions, useShouldFloatToolbar } from '../../shared/utils';
import { PuzzleNames, PuzzleNamesForUI } from '../../../../utils/types';
import StatsDialog from '../../shared/StatsDialog';
import DesktopToolbar from './DesktopToolbar';
import { MorphologyStore } from '../MorphologyStore';
import { saveMorphology } from '../morphologyUtils';
import Instructions from './Instructions';
import '../../shared/PuzzleTopBar/PuzzleTopBar.less';

const MorphologyTopBar = () => {
  const { completed, time, isPaused } = MorphologyStore.useState();

  const useFloatingToolbar = useShouldFloatToolbar(105);
  const useMobileStyles = isMobile || useIsMobileDimensions();
  const navigate = useNavigate();

  const pauseButtonClass = completed ? 'hidden' : '';

  return (
    <div className={`puzzleTopBar ${useMobileStyles ? 'mobile' : ''}`}>
      <div className="topBarLeftSection">
        <IconButton disableRipple title="Back" onClick={() => {
          navigate('/');
          window.scrollTo(0, 0);
          saveMorphology();
        }}>
          <KeyboardBackspaceIcon/>
        </IconButton>
        <div className="navigationLabel">{PuzzleNamesForUI[PuzzleNames.Morphology]}</div>
      </div>

      <div className="topBarMiddleSection">
        <div className="timer">{formatTime(time)}</div>
        <IconButton className={pauseButtonClass} title="Pause" onClick={() => {
          MorphologyStore.update(s => {
            if (!s.isPaused) {
              saveMorphology();
            }
            s.isPaused = !s.isPaused;
          });
          window.scrollTo(0, 0);
        }}>
          {isPaused ? <PlayArrowIcon/> : <PauseIcon/>}
        </IconButton>
      </div>

      <div className="topBarRightSection">
        <Instructions/>
        <StatsDialog puzzleName={PuzzleNames.Morphology} store={MorphologyStore as any} />

        {useFloatingToolbar && <DesktopToolbar/>}

        <IconButton disableRipple title="How to Play" onClick={() => {
          MorphologyStore.update(s => {
            s.instructionsAreOpen = true;
            s.isSoftPaused = true;
          });
        }}>
          <HelpOutlineIcon/>
        </IconButton>

        <IconButton disableRipple title="Stats" onClick={() => {
          MorphologyStore.update(s => {
            s.statsDialogIsOpen = true;
            s.isSoftPaused = true;
          });
        }}>
          <EqualizerIcon/>
        </IconButton>
      </div>
    </div>
  );
};

export default MorphologyTopBar;